import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  cardStyle: {
    padding: "12px",
    width: "261px",
    height: "264px",
    borderRadius: "20px",
    border: `1px solid ${theme.palette.border.secondary}`,
    background: theme.palette.utility.utility_gray_50,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  imageBox: {
    width: "100%",
    height: "200px",
    borderRadius: "20px",
    backgroundColor: theme.palette.background.paper,
  },
  detailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
